export const removeHost = url => {
  if (!url) return url;
  const urlObject = new URL(url);
  return urlObject.pathname + urlObject.search;
};
